// src/Components/ShortsContext.js
import { createContext, useContext, useState } from "react";

export const ShortsContext = createContext({
  isViewingShorts: false,
  setIsViewingShorts: () => {},
});

export const ShortsProvider = ({ children }) => {
  const [isViewingShorts, setIsViewingShorts] = useState(false);

  return (
    <ShortsContext.Provider value={{ isViewingShorts, setIsViewingShorts }}>
      {children}
    </ShortsContext.Provider>
  );
};

export const useShorts = () => useContext(ShortsContext);